<template>
	<div class="register_container">
		<div class="img-form">
			<div class="avatar_box">
				<!--        <img src="../assets/images/login/bg.png" alt="">-->
				<img src="../assets/images/login/resbg.png" alt="" />

				<el-dropdown class="message-wrap" placement="bottom" :show-timeout="0">
					<el-button type="primary" size="mini" plain>{{ $t('_lang') }}</el-button>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item v-for="(val, key) in i18nMessages" :key="key" @click.native="changeLang(key)">{{ val._lang }}</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>

				<div class="footer-container">
					<!--        <div class="footer">千仓科技2供应链，专注中日国际物流</div>-->
					<!--        <div class="about">Copyright © www.zxwl.com, All Rights Reserved.</div>-->
				</div>
			</div>
			<div class="register_box">
				<!-- 表单 -->
				<div class="register_box_content">
					<div class="rText">{{ $t('loginR.login8') }}</div>
					<el-form ref="registerFormRef" :model="registerForm" label-width="0" :rules="registerFormRules" class="register_form">
						<el-form-item prop="userName">
							<el-input v-model.trim="userName" :placeholder="$t('loginR.login36')"></el-input>
						</el-form-item>
						<el-form-item prop="realName">
							<el-input v-model.trim="registerForm.realName" :placeholder="$t('loginR.login37')"></el-input>
						</el-form-item>
						<el-form-item prop="emailAddress">
							<el-input v-model.trim="registerForm.emailAddress" type="email" :placeholder="$t('loginR.login9')"></el-input>
						</el-form-item>
						<!-- <el-form-item prop="mobileNumber">
            <el-input
            v-model="registerForm.mobileNumber"
            placeholder="请输入手机号码"></el-input>
          </el-form-item>-->
						<el-form-item prop="authCode" class="fu">
							<el-input v-model.trim="registerForm.authCode" :placeholder="$t('changeAccount.changeAccount13')" auto-complete="new-password"></el-input>
							<el-link :underline="false" class="getVal" @click="getCode">{{ $t('changeAccount.changeAccount14') }}</el-link>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model.trim="registerForm.password" type="password" auto-complete="new-password" :placeholder="$t('login.login21')"></el-input>
						</el-form-item>
						<el-form-item prop="confirmPassword">
							<el-input v-model.trim="registerForm.confirmPassword" type="password" :placeholder="$t('login.login22')"></el-input>
						</el-form-item>
						<el-form-item style="margin-bottom:45px !important" prop="isAgree">
							<template>
								<el-checkbox v-model="checked">{{ $t('login.login23') }}</el-checkbox>
							</template>
							<el-link :underline="false" href="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com/oytqc/instructions/%E3%82%A2%E3%83%AB%E3%83%80%E6%A0%AA%E5%BC%8F%E4%BC%9A%E7%A4%BE%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84.pdf" target="_blank">{{ $t('login.login24') }}</el-link>
						</el-form-item>
						<el-form-item class="btnGo">
							<el-button class="btns" type="primary" @click="register"
								><span class="goText">{{ $t('login.login25') }}</span></el-button
							>
						</el-form-item>
					</el-form>
				</div>
				<el-link type="primary" :underline="false" class="registerText ml-55" @click="login">{{ $t('login.login26') }}</el-link>
			</div>
		</div>
	</div>
</template>

<script>
import { messages, setLang } from '@/i18n';

export default {
	data() {
		var validatePassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('loginR.login17')));
			} else if (value !== this.registerForm.password) {
				callback(new Error(this.$t('loginR.login18')));
			} else {
				callback();
			}
		};
		var validateIsAgree = (rule, value, callback) => {
			if (this.checked) {
				callback();
			} else {
				callback(new Error(this.$t('login.login27')));
			}
		};
		return {
			i18nMessages: messages,
			checked: false,
			registerForm: {
				userName: '',
				password: '',
				realName: '',
				confirmPassword: '',
				mobileNumber: '',
				emailAddress: '',
				authCode: ''
			},
			registerFormRules: {
				userName: [
					{ required: true, message: this.$t('login.login3'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							var reg = /^(?![0-9]+$)(?![a-z]+$)[0-9a-z]{6,20}$/; //6-20位小写字母和数字
							var reg1 = /^[0-9]{6,20}$/; //6-20位数字
							var reg2 = /^[a-z]{6,20}$/; //6-20位小写字母
							var reg3 = /^[A-Z]{6,20}$/; //6-20位大写字母
							if (reg.test(value) || reg1.test(value) || reg2.test(value) || reg3.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login28')));
							}
						},
						trigger: 'blur'
					}
				],
				password: [
					{ required: true, message: this.$t('loginR.login16'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							var reg = /^(?![0-9]+$)(?![A-Z]+$)(?![a-z]+$)[0-9A-Za-z]{6,16}$/; //6-20位小写字母和数字
							if (reg.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login29')));
							}
						},
						trigger: 'blur'
					}
				],
				mobileNumber: [
					{ required: true, message: this.$t('login.login30'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							const regMobile = /^[1][3,4,5,7,8][0-9]{9}$/;
							if (regMobile.test(value)) {
								callback();
							}
							callback(new Error(this.$t('login.login31')));
						},
						trigger: 'blur'
					}
				],
				emailAddress: [
					{ required: true, message: this.$t('loginR.login9'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							const regMobile = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/i;
							if (regMobile.test(value)) {
								callback();
							}
							callback(new Error(this.$t('login.login31')));
						},
						trigger: 'blur'
					}
				],
				confirmPassword: [
					{ required: true, message: this.$t('login.login32'), trigger: 'blur' },
					{ validator: validatePassword, trigger: 'blur', required: true }
				],
				authCode: [
					{ required: true, message: this.$t('changeAccount.changeAccount13'), trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							var reg = /^[0-9]{4}$/; //6-20位小写字母和数字
							if (reg.test(value)) {
								callback();
							} else {
								callback(new Error(this.$t('login.login35')));
							}
						},
						trigger: 'blur'
					}
				],
				realName:[
					{required: true,message: this.$t('loginR.login37'),trigger: 'blur'},
					{max:50, trigger: 'blur'}
				],
				isAgree: [
					//{required:true,message:'请同意《用户协议》',trigger:'change'},
					{ validator: validateIsAgree, trigger: 'change', required: true }
				]
			}
		};
	},
	computed: {
		userName: {
			get: function () {
				return this.registerForm.userName;
			},
			set: function (val) {
				this.registerForm.userName = val.toLowerCase();
			}
		}
	},
	methods: {
		changeLang(key) {
			this.$i18n.locale = key;
			setLang(key);
		},
		login() {
			this.$router.push({
				name: 'login'
			});
		},
		resetregisterForm() {
			this.$refs.registerFormRef.resetFields();
		},
		register() {
			this.$refs['registerFormRef'].validate(async (valid) => {
				if (valid) {
					const { data: res } = await this.$http.post('admin/register', this.registerForm);
					if (res.code == 200) {
						this.$message({
							message: this.$t('login.login33'),
							type: 'success'
						});
						this.$router.push({
							name: 'login'
						});
					} else {
						this.$message({
							message: res.message,
							type: 'error'
						});
					}
				} else {
					this.$message({
						message: this.$t('login.login34'),
						type: 'error'
					});
				}
			});
		},
		async getCode() {
			var url = 'admin/sendVerificationCode';
			const { data: res } = await this.$http.get(url, {
				params: {
					email: this.registerForm.emailAddress,
					smsType: '0'
				}
			});
			console.log(res.code);
			if (res.code == 200) {
				this.$message({
					message: this.$t('changeAccount.changeAccount16'),
					type: 'success'
				});
			} else {
				console.log(this.registerForm.emailAddress);
				this.$message({
					message: res.message,
					type: 'error'
				});
			}
		},
		toLowerCase(value) {
			if (value) {
				value = value.toLowerCase();
			}
		}
	}
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
	margin-bottom: 30px !important;
}
.register_container {
	height: 100%;
	width: 100%;
	// background: url("../assets/images/login/bg.png") no-repeat;
	background-size: cover;
}
//.register_box{
//  position: relative;
//}
.registerText {
	position: relative;
	bottom: 7%;
	margin-left: 59px;
}
.register_box_content {
	//padding: 15%;
	//padding-top: 30%;
}
.img-form {
	overflow: hidden;
	height: 100%;
	.avatar_box {
		position: relative;
		float: left;
		width: 100%;
		height: 100%;
		img {
			width: 100%;
			height: 100%;
		}
		.message-wrap {
			position: absolute;
			top: 30px;
			right: 30px;
		}
	}
	.register_box {
		position: absolute;
		width: 290px;
		height: 660px;
		left: 208px;
		top: 50%;
		margin-top: -330px;
	}
}

@media screen and (min-width: 1600px) {
	//.avatar_box{
	//  width: 75% !important;
	//}
	//.register_box{
	//  width: 25% !important;
	//}
}

.register_form {
	bottom: 0;
	width: 100%;
	padding: 0px;
	box-sizing: border-box;
}
.btns {
	// display: flex;
	// justify-content:flex-end;
	// width: 370px;
	padding-top: 10px;
	margin-top: 20px;
	width: 263px;
	height: 38px;
	// line-height: 45px;
	background: linear-gradient(90deg, #269f98, #2e85a1);
	border-radius: 30px;
	color: #ffffff;
}

.btnGo {
	//overflow: auto;
	position: relative;
	top: -37px;
	margin-left: 55px;
}

.btns span {
	font-size: 17px !important;
}

/deep/ .el-input__prefix,
.el-input__suffix {
	color: green !important;
}

/deep/ .el-input__icon .el-icon-user-solid {
	color: green !important;
}
.footer-container {
	width: 100%;
	position: absolute;
	bottom: 10%;
	text-align: center;
}
.footer {
	font-size: 30px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	letter-spacing: 4px;
	color: #fefeff;
}

.about {
	font-size: 16px;
	font-family: Source Han Sans CN;
	// font-weight: 400;
	color: #fefeff;
	padding-top: 10px;
}

.getVal {
	position: absolute;
	margin-top: 10px;
	width: 112px;
	height: 18px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1373fb;
	line-height: 40px;
	margin-left: 10px;
}

.rText {
	width: 200px;
	height: 46px;
	font-size: 48px;
	font-family: Lantinghei SC;
	font-weight: 600;
	color: #3a4255;
	text-shadow: 0px 3px 3px rgba(34, 40, 66, 0.43);
	margin-bottom: 50px;
}

/deep/ .el-input__inner {
	border: none !important;
	border-bottom: 1px solid #e5e9f8 !important;
	width: 415px;
}
/deep/ .el-input--prefix .el-input__inner {
	padding-left: 40px !important;
}
.fu {
	position: relative;
}
.ml-55{
	margin-left: 115px !important;
}
</style>
